/**
 * Homepage banner carousel, loaded from partials/banner.blade.php. Markup
 * contract: #carouselExampleControls wrapping .dlz-carousel-item slides, plus
 * #carousel-prev / #carousel-next controls.
 */
(function () {
    function initCarousel() {
        var carousel = document.getElementById('carouselExampleControls');
        if (!carousel) return;
        var items = carousel.querySelectorAll('.dlz-carousel-item');
        var total = items.length;
        if (total < 2) return;

        var currentIndex = 0;
        var isAnimating = false;

        function goTo(newIndex, direction) {
            if (isAnimating) return;
            isAnimating = true;
            var current = items[currentIndex];
            var next = items[newIndex];
            var enterClass = direction === 'next' ? 'dlz-carousel-item-next' : 'dlz-carousel-item-prev';
            var leaveClass = direction === 'next' ? 'dlz-carousel-item-start' : 'dlz-carousel-item-end';
            next.classList.add(enterClass);
            next.offsetWidth; // force reflow to trigger CSS transition
            current.classList.add(leaveClass);
            next.classList.add(leaveClass);
            function onTransitionEnd() {
                current.removeEventListener('transitionend', onTransitionEnd);
                current.classList.remove('active', leaveClass);
                next.classList.remove(enterClass, leaveClass);
                next.classList.add('active');
                currentIndex = newIndex;
                isAnimating = false;
            }
            current.addEventListener('transitionend', onTransitionEnd);
            // Safety: if CSS transition is suppressed (prefers-reduced-motion, hidden element),
            // transitionend may never fire — prevent carousel from freezing
            setTimeout(function () { if (isAnimating) onTransitionEnd(); }, 1000);
        }

        function nextSlide() { goTo((currentIndex + 1) % total, 'next'); }
        function prevSlide() { goTo((currentIndex - 1 + total) % total, 'prev'); }

        var autoPlay = setInterval(nextSlide, 5000);

        document.getElementById('carousel-next').addEventListener('click', function (e) {
            e.preventDefault();
            clearInterval(autoPlay);
            nextSlide();
            autoPlay = setInterval(nextSlide, 5000);
        });
        document.getElementById('carousel-prev').addEventListener('click', function (e) {
            e.preventDefault();
            clearInterval(autoPlay);
            prevSlide();
            autoPlay = setInterval(nextSlide, 5000);
        });
    }

    // Defer init past initial paint; setTimeout fallback for Safari < 16.4.
    if ('requestIdleCallback' in window) {
        requestIdleCallback(initCarousel, { timeout: 2000 });
    } else {
        setTimeout(initCarousel, 100);
    }
})();
